/* eslint-disable no-case-declarations */
import {
  SUBSCRIBE_POSITION_UPDATES,
  UNSUBSCRIBE_POSITION_UPDATES,
  ALGO_LIVE_TOGGLE_SELECT_LEG,
  ALGO_LIVE_SELECT_LEG_ALL,
  ALGO_LIVE_EXIT_SELECTED_START,
  ALGO_LIVE_EXIT_SELECTED_STOP,
  ALGO_LIVE_RESET,
} from '../../constants/ActionTypes';
import { processLiveFeed, updateToggleLegSelect } from './updaters';

function getFilteredSymbols(positions, symbols) {
  if (!positions.length && !symbols.length) {
    return [[], false];
  } else if (!positions.length && symbols.length) {
    return [[], true];
  }

  const newSymbolArray = [];

  let updated = false;

  for (let index = 0; index < positions.length; index++) {
    const position = positions[index];

    if (!position.symbol) {
      continue;
    }

    if (!newSymbolArray.includes(position.symbol)) {
      newSymbolArray.push(position.symbol);
    }

    if (!symbols.includes(position.symbol)) {
      updated = true;
    }
  }

  return [newSymbolArray, updated];
}

const algoLive = (
  state = {
    data: {},
    selectedLegs: [],
    selectAll: false,
    isFetching: false,
    errorMessage: null,
    exitSelectedStart: false,
    symbols: [],
    liveFeedUpdatedAt: null,
    symbolsUpdatedAt: null,
  },
  action
) => {
  switch (action.type) {
    case SUBSCRIBE_POSITION_UPDATES:
      const data = processLiveFeed(action.data, state);

      const [newSymbolArray, isSymbolsupdated] = getFilteredSymbols(
        data?.state?.positions || [],
        state.symbols
      );

      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: processLiveFeed(action.data, state),
        liveFeedUpdatedAt: Date.now(),
        symbols: isSymbolsupdated ? newSymbolArray : state.symbols,
        symbolsUpdatedAt: isSymbolsupdated
          ? Date.now()
          : state.symbolsUpdatedAt,
      };
    case UNSUBSCRIBE_POSITION_UPDATES:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: {},
      };
    case ALGO_LIVE_TOGGLE_SELECT_LEG:
      const toggleLegSelect = updateToggleLegSelect(state, action);
      const toggleLegselectAll = toggleLegSelect.length
        ? state.selectAll
        : false;

      return {
        ...state,
        selectedLegs: toggleLegSelect,
        selectAll: toggleLegselectAll,
      };
    case ALGO_LIVE_SELECT_LEG_ALL:
      const LegSelectselectAll = action.value.length ? action.select : false;

      return {
        ...state,
        selectedLegs: action.value,
        selectAll: LegSelectselectAll,
      };
    case ALGO_LIVE_EXIT_SELECTED_START:
      return {
        ...state,
        exitSelectedStart: true,
      };
    case ALGO_LIVE_EXIT_SELECTED_STOP:
      return {
        ...state,
        exitSelectedStart: false,
      };
    case ALGO_LIVE_RESET:
      return {
        ...state,
        data: {},
        selectedLegs: [],
        selectAll: false,
        isFetching: false,
        errorMessage: null,
        exitSelectedStart: false,
        symbols: [],
        liveFeedUpdatedAt: null,
        symbolsUpdatedAt: null,
      };
    default:
      return state;
  }
};

export default algoLive;
